import { baseApi } from "./baseApi";

interface CustomDomainResponse {
  prefix: string | null;
}

interface CheckAvailabilityResponse {
  available: boolean;
}

const customDomainApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomDomain: builder.query<CustomDomainResponse, void>({
      query: () => "/settings/customer-portal/custom-domain",
      providesTags: [{ type: "Instance" as const, id: "CUSTOM_DOMAIN" }],
    }),

    updateCustomDomain: builder.mutation<CustomDomainResponse, { prefix: string | null }>({
      query: (body) => ({
        url: "/settings/customer-portal/custom-domain",
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "Instance" as const, id: "CUSTOM_DOMAIN" }],
    }),

    checkDomainAvailability: builder.query<CheckAvailabilityResponse, string>({
      query: (prefix) =>
        `/settings/customer-portal/custom-domain/check?prefix=${encodeURIComponent(prefix)}`,
    }),
  }),
});

export const {
  useGetCustomDomainQuery,
  useUpdateCustomDomainMutation,
  useLazyCheckDomainAvailabilityQuery,
} = customDomainApi;
